<h1 mat-dialog-title translate>m1+2.data-result.enterprise-info-completion.title</h1>
<div mat-dialog-content>
  <p translate>m1+2.data-result.enterprise-info-completion.explanation-text</p>
  <form [formGroup]="enterpriseInfoForm">
    <mat-form-field>
      <mat-label>{{'i18n.enterpriseInfo.label.firma-institution' | translate}}</mat-label>
      <input matInput formControlName="firma">
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'i18n.enterpriseInfo.label.uid' | translate}}</mat-label>
      <input matInput formControlName="uid">
    </mat-form-field>
    <mat-form-field>
      <mat-label translate>m1+2.sprint8.enterprise-info.fachperson.label</mat-label>
      <input matInput formControlName="fachperson">
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button obButton="primary" [mat-dialog-close]="data" cdkFocusInitial>{{'i18n.common.next' | translate}}</button>
</div>
